export const CONTACT_US_SUBMIT_START = 'CONTACT_US_SUBMIT_START';
export const CONTACT_US_SUBMIT_SUCCESS = 'CONTACT_US_SUBMIT_SUCCESS';
export const CONTACT_US_SUBMIT_FAIL = 'CONTACT_US_SUBMIT_FAIL';
export const CONTACT_US_SUBMIT_RESET = 'CONTACT_US_SUBMIT_RESET';
